/**
 * Navigation configuration with role-based access control
 * Each menu item can specify required roles for visibility
 */

export const navigationConfig = {
  // Main sidebar navigation items
  sidebar: [
    {
      id: 'projects',
      title: 'Проекты',
      icon: 'bi bi-folder',
      route: null,
      roles: [], // Available to all authenticated users
      authenticated: true, // Require authentication
      expandable: true,
      children: [
        {
          id: 'create-project',
          title: 'Создать проект',
          icon: 'bi bi-plus-square',
          route: '/create-project',
          roles: []
        },
        {
          id: 'all-projects',
          title: 'Все проекты',
          icon: 'bi bi-list-ul',
          route: '/projects',
          roles: []
        }
      ]
    },
    {
      id: 'monitoring',
      title: 'Мониторинг',
      icon: 'bi bi-activity',
      route: null,
      roles: [], // Available to all authenticated users
      authenticated: true,
      expandable: true,
      children: [
        {
          id: 'messages',
          title: 'Сообщения',
          icon: 'bi bi-chat-left-text',
          route: '/monitoring/messages',
          roles: []
        },
        {
          id: 'entities',
          title: 'Сущности',
          icon: 'bi bi-people',
          route: '/monitoring/entities',
          roles: []
        },
        {
          id: 'statistics',
          title: 'Статистика',
          icon: 'bi bi-bar-chart-line',
          route: '/dashboard',
          roles: []
        },
        {
          id: 'reports',
          title: 'Отчёты',
          icon: 'mdi-file-chart',
          route: '/monitoring/reports',
          roles: []
        }
      ]
    },
    {
      // OSINT-инструменты: анализ связей источников. Право feature:osint (роль osint), админ видит всегда.
      id: 'osint',
      title: 'OSINT',
      icon: 'mdi-radar',
      route: null,
      roles: [],
      permission: 'feature:osint',
      authenticated: true,
      expandable: true,
      children: [
        {
          // Сети Telegram-каналов — кластеры графа связей (core/docs/telegram_channel_networks.md)
          id: 'networks',
          title: 'Сети ТГ каналов',
          icon: 'mdi-graph',
          route: '/monitoring/networks',
          roles: []
        }
      ]
    },
    {
      id: 'sources',
      title: 'Мои источники',
      icon: 'bi bi-database',
      route: null,
      roles: [], // Visible to all authenticated users — их персональные источники
      authenticated: true,
      expandable: true,
      children: [
        {
          // Только Telegram-каналы пользователя + колонка «Сетка» и граф связей
          // (core/docs/telegram_channel_networks.md)
          id: 'user-sources-telegram',
          title: 'Телеграм',
          icon: 'bi bi-telegram',
          route: '/monitoring/my-sources?tab=telegram',
          roles: []
        },
        {
          id: 'user-sources-social',
          title: 'Соцсети',
          icon: 'mdi-account-star',
          route: '/monitoring/my-sources?tab=social',
          roles: []
        },
        {
          id: 'user-sources-web',
          title: 'Сайты',
          icon: 'mdi-web-box',
          route: '/monitoring/my-sources?tab=web',
          roles: []
        },
        {
          id: 'user-sources-search',
          title: 'Поисковые системы',
          icon: 'mdi-magnify',
          route: '/monitoring/my-sources?tab=search',
          roles: []
        }
      ]
    },
    {
      // Глобальный курируемый пул Source (общий мониторинговый набор + каталог),
      // к которому линкуются проекты всех пользователей. Термин «общие» — из вики
      // (billing.md: «источник, созданный пользователем, сразу общий»).
      id: 'common-sources',
      title: 'Общие источники',
      icon: 'mdi-earth',
      route: null,
      roles: ['admin'], // admin only
      authenticated: true,
      expandable: true,
      children: [
        {
          id: 'telegram',
          title: 'Телеграм',
          icon: 'bi bi-telegram',
          route: '/admin/telegram',
          roles: ['admin']
        },
        {
          id: 'dzen',
          title: 'Дзен',
          icon: 'mdi-fire',
          route: '/admin/dzen',
          roles: ['admin']
        },
        {
          id: 'x',
          title: 'X.com',
          icon: 'mdi-alpha-x-circle',
          route: '/admin/x',
          roles: ['admin']
        },
        {
          id: 'websites',
          title: 'Сайты',
          icon: 'mdi-web',
          route: '/admin/websites',
          roles: ['admin']
        }
      ]
    },
    {
      // Словари: языки, платформы, типы СМИ, темы, геолокации — НЕ источники.
      id: 'references',
      title: 'Справочники',
      icon: 'mdi-bookshelf',
      route: '/admin/references',
      roles: ['admin'],
      authenticated: true,
      children: []
    },
    {
      id: 'authors',
      title: 'Авторы',
      icon: 'bi bi-people',
      route: '/admin/authors',
      roles: ['admin'],
      authenticated: true,
      children: []
    },
    // Commented out - not implemented yet
    // {
    //   id: 'search-sites',
    //   title: 'Сайты для поиска',
    //   icon: 'bi bi-search',
    //   route: '/search-sites',
    //   roles: ['admin'],
    //   authenticated: true,
    //   children: []
    // },
    // {
    //   id: 'categories',
    //   title: 'Рубрики',
    //   icon: 'bi bi-tags',
    //   route: '/categories',
    //   roles: ['admin'],
    //   authenticated: true,
    //   children: []
    // },
    {
      id: 'notifications',
      title: 'Уведомления',
      icon: 'bi bi-bell',
      route: '/notifications',
      roles: [],
      authenticated: true, // Require authentication
      children: []
    }
  ],
  
  // Header navigation items
  header: [
    // Admin dropdown menu
    {
      id: 'admin',
      title: 'Администрирование',
      icon: 'bi bi-gear',
      route: null,
      roles: ['admin'], // Admin only
      authenticated: true,
      expandable: true,
      children: [
        {
          id: 'user-management',
          title: 'Управление пользователями',
          route: '/admin/users',
          roles: ['admin']
        },
        {
          id: 'invitation-codes',
          title: 'Коды приглашений',
          route: '/admin/invitations',
          roles: ['admin']
        },
        {
          id: 'general-settings',
          title: 'Общие настройки',
          route: '/admin/settings',
          roles: ['admin']
        },
        {
          id: 'auth-events',
          title: 'Журнал входов',
          route: '/admin/auth-events',
          roles: ['admin']
        },
        {
          id: 'plans',
          title: 'Тарифы',
          route: '/admin/plans',
          roles: ['admin']
        },
        {
          id: 'admin-teams',
          title: 'Команды',
          icon: 'mdi-account-group-outline',
          route: '/admin/teams',
          roles: ['admin']
        },
        {
          id: 'admin-notifications',
          title: 'Уведомления',
          icon: 'mdi-bell-outline',
          route: '/admin/notifications',
          roles: ['admin']
        },
        {
          id: 'admin-help',
          title: 'Справка',
          icon: 'mdi-help-circle-outline',
          route: '/admin/help',
          roles: ['admin']
        },
        {
          id: 'llm-costs',
          title: 'Расходы LLM',
          route: '/admin/llm-costs',
          roles: ['admin']
        },
        {
          id: 'system-monitoring',
          title: 'Мониторинг системы',
          route: '/admin/monitoring',
          roles: ['admin']
        },
        {
          id: 'source-configuration',
          title: 'Настройка источников',
          route: '/admin/sources',
          roles: ['admin']
        },
        {
          id: 'prompts-management',
          title: 'LLM Промты',
          route: '/admin/prompts',
          roles: ['admin']
        },
        {
          id: 'social-accounts',
          title: 'Аккаунты для скрапинга',
          route: '/admin/social-accounts',
          roles: ['admin']
        },
        {
          id: 'admin-proxies',
          title: 'Управление прокси',
          route: '/admin/proxies',
          roles: ['admin']
        },
        {
          id: 'admin-roles',
          title: 'Роли и права',
          icon: 'mdi-shield-account-outline',
          route: '/admin/roles',
          roles: ['admin']
        }
      ]
    },
    {
      id: 'help',
      title: 'Справка',
      icon: 'mdi-help-circle-outline',
      route: '/help',
      roles: [], // Available to all authenticated users
      authenticated: true
    },
    {
      id: 'profile',
      title: 'Профиль',
      route: '/profile',
      roles: [], // Available to all authenticated users
      authenticated: true
    },
    {
      id: 'signout',
      title: 'Выход',
      route: '/signout',
      roles: [], // Available to all authenticated users
      authenticated: true
    },
    {
      id: 'signin',
      title: 'Вход',
      route: '/signin',
      roles: [],
      authenticated: false
    },
    {
      id: 'signup',
      title: 'Регистрация',
      route: '/signup',
      roles: [],
      authenticated: false
    }
  ]
};

/**
 * Filter navigation items based on user roles
 * @param {Array} items - Navigation items to filter
 * @param {Array} userRoles - Current user roles
 * @param {Boolean} isAuthenticated - Whether user is authenticated
 * @returns {Array} Filtered navigation items
 */
export function filterNavigationByRoles(items, userRoles = [], isAuthenticated = false, userPermissions = []) {
  const isAdmin = userRoles.includes('admin');
  return items.filter(item => {
    // Check authentication requirement
    if (item.authenticated !== undefined) {
      if (item.authenticated && !isAuthenticated) return false;
      if (!item.authenticated && isAuthenticated) return false;
    } else {
      // If authenticated property is not set, require authentication for sidebar items by default
      // This ensures backward compatibility
      if (!isAuthenticated) return false;
    }
    
    // Право-фича (permission: 'feature:onion_sources'): админ видит всегда
    if (item.permission && !isAdmin && !userPermissions.includes(item.permission)) {
      return false;
    }

    // If no roles specified, item is public
    if (!item.roles || item.roles.length === 0) {
      return true;
    }
    
    // Check if user has at least one required role
    const hasRequiredRole = item.roles.some(role => userRoles.includes(role));
    if (!hasRequiredRole) {
      return false;
    }
    
    // If item has children, filter them recursively
    if (item.children && item.children.length > 0) {
      const filteredChildren = filterNavigationByRoles(item.children, userRoles, isAuthenticated, userPermissions);
      // Only include parent if it has visible children
      if (filteredChildren.length === 0 && !item.route) {
        return false;
      }
      // Return item with filtered children
      return {
        ...item,
        children: filteredChildren
      };
    }
    
    return true;
  }).map(item => {
    // Process items that passed the filter
    if (item.children && item.children.length > 0) {
      return {
        ...item,
        children: filterNavigationByRoles(item.children, userRoles, isAuthenticated)
      };
    }
    return item;
  });
}

/**
 * Get filtered sidebar navigation based on user roles
 * @param {Array} userRoles - Current user roles
 * @param {Boolean} isAuthenticated - Whether user is authenticated
 * @returns {Array} Filtered sidebar navigation items
 */
export function getSidebarNavigation(userRoles = [], isAuthenticated = false, userPermissions = []) {
  return filterNavigationByRoles(navigationConfig.sidebar, userRoles, isAuthenticated, userPermissions);
}

/**
 * Get filtered header navigation based on user roles
 * @param {Array} userRoles - Current user roles
 * @param {Boolean} isAuthenticated - Whether user is authenticated
 * @returns {Array} Filtered header navigation items
 */
export function getHeaderNavigation(userRoles = [], isAuthenticated = false) {
  return filterNavigationByRoles(navigationConfig.header, userRoles, isAuthenticated);
}

/**
 * Check if a specific route is accessible by user roles
 * @param {String} route - Route path to check
 * @param {Array} userRoles - Current user roles
 * @returns {Boolean} Whether route is accessible
 */
export function isRouteAccessible(route, userRoles = []) {
  const checkItems = (items) => {
    for (const item of items) {
      if (item.route === route) {
        if (!item.roles || item.roles.length === 0) return true;
        return item.roles.some(role => userRoles.includes(role));
      }
      if (item.children) {
        const childResult = checkItems(item.children);
        if (childResult !== null) return childResult;
      }
    }
    return null;
  };
  
  const sidebarResult = checkItems(navigationConfig.sidebar);
  if (sidebarResult !== null) return sidebarResult;
  
  const headerResult = checkItems(navigationConfig.header);
  if (headerResult !== null) return headerResult;
  
  // Route not found in navigation config, allow by default
  return true;
}

/**
 * Get all routes that require specific roles
 * @returns {Object} Map of routes to required roles
 */
export function getProtectedRoutes() {
  const routes = {};
  
  const extractRoutes = (items) => {
    items.forEach(item => {
      if (item.route && item.roles && item.roles.length > 0) {
        routes[item.route] = item.roles;
      }
      if (item.children) {
        extractRoutes(item.children);
      }
    });
  };
  
  extractRoutes(navigationConfig.sidebar);
  extractRoutes(navigationConfig.header);
  
  return routes;
}